<template>
  <v-card>
    <v-form class="pa-2">
      <v-container fluid>
        <v-row dense>
          <v-col cols="12">
            <v-row dense>
              <h2>Filtros</h2>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-select
            v-model="selectedLojas"
            :items="filtroLojas"
            label="Loja"
            prepend-icon="mdi-storefront-outline"
            multiple
            clearable
            outlined
            small-chips
            dense
          ></v-select>
          <v-spacer></v-spacer>

          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="computedDateFormattedMomentDataInicial"
                clearable
                label="Data Inicial"
                prepend-icon="mdi-calendar"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              color="green lighten-3"
              v-model="dataInicial"
              @change="menu1 = null"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>

          <v-spacer></v-spacer>

          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            min-width="190px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="computedDateFormattedMomentDataFinal"
                clearable
                label="Data Final"
                prepend-icon="mdi-calendar"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              color="green lighten-3"
              v-model="dataFinal"
              @change="menu2 = null"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
          <v-spacer></v-spacer>

          <div class="mr-2">
            <v-btn color="primary" @click="chamaMetodo" fab small dark>
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </div>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      switch1: true,
      selectedLojas: [1, 6],
      filtroLojas: [],
      // selectTipoCliente: [],
      // selectCanal: [],

      // filtroTipoCliente: ["Todos", "Fisica", "Juridica", "Outros"],
      // filtroCanal: ["Todos", "Humano", "Vetreinário"],
      dataInicial: new Date().toISOString().substr(0, 10),
      dataFinal: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
    };
  },
  mounted() {
    this.preencheListaLojas();
  },
  computed: {
    computedDateFormattedMomentDataInicial() {
      return this.dataInicial
        ? moment(this.dataInicial).format("DD/MM/YYYY")
        : "";
    },
    computedDateFormattedMomentDataFinal() {
      return this.dataFinal ? moment(this.dataFinal).format("DD/MM/YYYY") : "";
    },
  },
  methods: {
    preencheListaLojas() {
      this.filtroLojas = [
        { value: 1, text: "Loja1" },
        { value: 6, text: "Loja6" },
      ];
    },
    chamaMetodo() {
      this.$emit("add-filtro-painel", {
        selectedLojas: this.selectedLojas,
        dataInicial: this.dataInicial,
        dataFinal: this.dataFinal,
      });
    },
  },
};
</script>

<style>
</style>